import { createActions } from 'redux-actions';
import { REDUX_STORE_SLICES } from '../services/exports/Constants';

export const actionCreators = createActions({
  [REDUX_STORE_SLICES.INITIAL_DATA]: {
    setAllData: undefined,
    setFranchise: undefined,
    setCompany: undefined,
    updateCompany: undefined,
    setCashbackAccount: undefined,
    setRewardAccount: undefined,
    toggleLoading: undefined,
    reset: undefined,
  },
  [REDUX_STORE_SLICES.PROFILE]: {
    setProfile: undefined,
  },
  [REDUX_STORE_SLICES.ORDER_METHOD]: {
    setOrderMethod: undefined,
  },
  [REDUX_STORE_SLICES.BASKET]: {
    addItem: undefined,
    addItems: undefined,
    removeItem: undefined,
    updateItem: undefined,
    clear: undefined,
    set: undefined,
  },
  [REDUX_STORE_SLICES.ORDER]: {
    setOrder: undefined,
    updateOrder: undefined,
    resetOrder: undefined,
    resetScheduledTime: undefined,
    addOngoingOrder: undefined,
    removeOngoingOrder: undefined,
  },
  [REDUX_STORE_SLICES.PAYMENT_FLOW]: {
    setSelectedPaymentMethod: undefined,
  },
  [REDUX_STORE_SLICES.PAYMENT_OPTIONS]: {
    setPaymentOptions: undefined,
    addPaymentOption: undefined,
    removePaymentOption: undefined,
    reset: undefined,
  },
  [REDUX_STORE_SLICES.PRODUCT_LIKES]: {
    likeProduct: undefined,
    unlikeProduct: undefined,
  },
  [REDUX_STORE_SLICES.APP_STATUS]: {
    setPickUpDeliveryPopupSeen: undefined,
    setEnvironment: undefined,
    setCookieConsent: undefined,
  },
  [REDUX_STORE_SLICES.EVENT_HELPER]: {
    setEvent: undefined,
    resetEvent: undefined,
  },
  [REDUX_STORE_SLICES.TRACKING]: {
    setUtm: undefined,
  },
});
